import { ColorTheme, ThemeOverrides } from '@dadohr/shared/domainTypes/theme';
import { Theme } from '@material-ui/core';

export interface IEMotionTheme {
  custom: {
    colors: Omit<ColorTheme, 'text'>;
    fontSize: {
      xs: number;
      s: number;
      m: number;
      l: number;
      xl: number;
    };
    border: {
      radius: (multiplier?: number) => number;
      color: string;
      standard: string;
    };
  };
}

export const createEmotionTheme = (
  baseTheme: Theme,
  otherOverrides?: ThemeOverrides
): IEMotionTheme => {
  // TODO handle all other colors that are not in the MUI theme - currently unused!
  return {
    custom: {
      border: {
        radius: (multiplier = 1) => 6 * multiplier,
        color: 'rgba(0, 0, 0, 0.1)',
        standard: '1px solid #dde0e3'
      },
      colors: {
        headerBackgroundDark: {
          main:
            otherOverrides?.colors?.headerBackgroundDark?.main ||
            baseTheme.palette.primary.main
        },
        primary: baseTheme.palette.primary,
        secondary: baseTheme.palette.secondary,
        success: {
          light: '#77d4a9',
          main: '#45ba83',
          dark: '#1a6133',
          contrastText: 'white'
        },
        pending: {
          light: '#f5e18c',
          dark: '#f6cc1b',
          main: '#f6cc1b',
          contrastText: 'white'
        },
        error: {
          light: '#f77b6e',
          main: '#e25e50',
          dark: '#bf3a2b',
          contrastText: 'white'
        },
        background: {
          light: '#ffffff',
          main: '#ffffff',
          dark: '#ffffff',
          contrastText: 'black'
        },

        red: {
          contrastText: 'white',

          w100: '#fef6f6',
          w200: '#fde3e1',
          w300: '#fdbcb4',
          w400: '#f77b6e',
          w500: '#e25e50',
          w600: '#db4332',
          w700: '#bf3a2b',
          w800: '#962e22',
          w900: '#41110b'
        },
        yellow: {
          contrastText: 'white',

          w100: '#fefaec',
          w200: '#fff6d1',
          w300: '#fff1b8',
          w400: '#fee580',
          w500: '#f6c955',
          w600: '#edb321',
          w700: '#d0a025',
          w800: '#8f6e19',
          w900: '#4f3c0c'
        },
        green: {
          contrastText: 'white',

          w100: '#f1f9f5',
          w200: '#daf7e9',
          w300: '#b3ead0',
          w400: '#75d7a9',
          w500: '#45ba83',
          w600: '#29995D',
          w700: '#115f2c',
          w800: '#11472a',
          w900: '#0d3620'
        },
        blue: {
          contrastText: 'white',

          w100: '#edf5fd',
          w200: '#e7f2fd',
          w300: '#c1defb',
          w400: '#6aB2fb',
          w500: '#0e78e4',
          w600: '#0061c4',
          w700: '#0454a4',
          w800: '#03407d',
          w900: '#033363'
        },
        purple: {
          contrastText: 'white',

          w100: '#f4f1ff',
          w200: '#ebe3ff',
          w300: '#d5c4ff',
          w400: '#9747ff',
          w500: '#7856ff',
          w600: '#6339e0',
          w700: '#502bb8',
          w800: '#3b2189',
          w900: '#251451'
        },
        gray: {
          contrastText: 'white',

          white: '#ffffff',
          w100: '#fafafa',
          w200: '#ebedef',
          w300: '#dde0e3',
          w400: '#bbc1c7',
          w500: '#778088',
          w600: '#5f676e',
          w700: '#494f55',
          w800: '#3a4147',
          w900: '#272c30',
          black: '#08121a'
        }
        // subText: {
        //   light: '#4f4f4f',
        //   main: '#4f4f4f',
        //   dark: '#4f4f4f',
        //   contrastText: '#4f4f4f'
        // }
      },
      fontSize: {
        xs: 11,
        s: 13,
        m: 15,
        l: 20,
        xl: 24
      }
    }
  };
};
